import { css, styled } from 'styled-components';
import mediaQuery, { Breakpoint, breakpoints } from '@/styles/mediaQuery';

export const LayoutDesktopContainer = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.system.neutral.surface.primary};
`;

export const LayoutDesktopContent = styled.main(
  ({ theme }) => css`
    .card {
      padding: ${theme.spaces.padding.xxl};
      background-color: ${theme.system.neutral.surface.primary};
      box-shadow: 0 0 30px 0 rgb(0 0 0 / 15%);
      max-width: 970px;
      min-width: 60%;
      margin: ${theme.spaces.padding['3xl']} auto;
      border-radius: ${theme.radius.base};
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      form {
        width: 100%;
      }
    }

    flex: 1;
    display: flex;
    align-items: center;

    h2 {
      font-weight: 300;
      margin-bottom: ${theme.spaces.padding.md} !important;
    }

    .checkbox {
      padding: 0;
      min-height: unset;

      & > label {
        font-weight: 300 !important;
      }
    }

    .action-link {
      display: block;
      text-align: right;
      font-weight: 400;
      cursor: pointer;
      transition: all ease-in 150ms;
      font-size: ${theme.typography.sizes.sm};
      margin-top: ${theme.spaces.padding.sm};
    }

    ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
      .card {
        padding: ${theme.spaces.padding.xl};
        margin: 64px 0;
        width: 100%;
        border: unset;
      }
    }
  `,
);

export const LayoutDesktopHeaderStyled = styled.header`
  height: 80px;
  background-color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.spaces.padding['3xl']};

  ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
    justify-content: center;
  }
`;

export const LayoutDesktopFooterStyled = styled.footer(
  ({ theme }) => css`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    background-color: ${theme.colors.primary};
    box-shadow: 0 0 30px 0 rgb(0 0 0 / 15%);
    color: ${theme.system.neutral.text.inverted};
    font-weight: 400;
    font-size: ${theme.typography.sizes.md};
    height: 128px;
    padding: ${theme.spaces.padding.xxl} ${theme.spaces.padding['3xl']};

    a {
      color: ${theme.system.neutral.text.inverted};
    }

    ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: ${theme.spaces.gap.md};
      height: auto;
      padding: ${theme.spaces.padding.lg} ${theme.spaces.padding.sm};
    }

    .text-version-number {
      color: ${theme.system.neutral.border.subtle};
    }
  `,
);

export const FullIframeLayoutDesktopContent = styled.main`
  height: 100vh;
`;

export const LayoutDesktopCustomHeaderStyled = styled.header.attrs({
  id: 'header',
})`
  min-height: 80px;
  width: 100vw;
`;

export const ViewLayoutWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
